import { lazy } from 'preact/compat';

//all the required css will go here
//[TODO] find a way to load it later
import '../widgets/location/style.scss';
import '../widgets/location/autocomplete.scss';
import '../widgets/affsearch/style.scss';
import '../widgets/weather/style.scss';
import '../widgets/map/style.scss';
import '../widgets/translate/translateStyle.scss';
import '../widgets/currconvert/style.scss';

const affsearchWdg = lazy(() => import('../widgets/affsearch/AffSearchWidget'));
const weatherWdg = lazy(() => import('../widgets/weather/WeatherWidget'));
const mapWdg = lazy(() => import('../widgets/map/mapWidget'));
const locationWdg = lazy(() => import('../widgets/location/LocationWidget'));
const currencyWdg = lazy(() => import('../widgets/currconvert/CurrConvertWidget'));
//new widgets
const calculatorWdg = lazy(() => import('../widgets/calculator/CalculatorWidget'));
const translateWdg = lazy(() => import('../widgets/translate/TranslateWidget'));


export const GetWidgetComponent = (wdgName) => {
    if (wdgName === 'affsearch') {
        return affsearchWdg;
    } else if (wdgName === 'weather') {
        return weatherWdg;
    } else if (wdgName === 'map') {
        return mapWdg;
    } else if (wdgName === 'location') {
        return locationWdg;
    } else if (wdgName === 'currency') {
        return currencyWdg;
    } else if (wdgName === 'calculator') {
        return calculatorWdg;
    } else if (wdgName === 'translate') {
        return translateWdg;
    } else {
        return null;
    }
} 

export const GetTopWidgetName = (location, searchResp) => {
    const hasTestFlag = () => {
        let url = window.location.href;
        if(url && url.indexOf("testflag=true") > -1) {
            return true;
        }
        return false;
    }

    // WIDGET WRITERS: any special "is" function you need go here
    const isShopping = (widgetinfo) => {
        if(widgetinfo && widgetinfo.direct_shopping &&
          widgetinfo.direct_shopping.shopping > widgetinfo.direct_shopping.direct &&
          widgetinfo.direct_shopping.shopping > widgetinfo.direct_shopping.notshopping) {
            return true;
        } else {
            //return false
            return true; //always put at top
        }
    }

    const isMap = (searchResp) => {
        let isPlaces = searchResp.places?.value?.length > 0;
        let showMapCase = false; 
        let mapWidgetInfo = searchResp.WidgetInfo.widgets?.find(obj => {
            return obj.name === "map"
        });
        if(mapWidgetInfo) {
            let placeType = mapWidgetInfo.parameters?.placetype?.[0];
            let location = mapWidgetInfo.parameters?.location?.[0];
            let address = mapWidgetInfo.parameters?.address?.[0];
            let addressMatch = mapWidgetInfo.parameters?.addressmatch?.[0];
            showMapCase = placeType || location || address || addressMatch;
        }
        if(isPlaces || showMapCase && searchResp.translations == undefined) {
            return true;
        } else {
            return false;
        }
    }

    const isCurrency = (widgetinfo) => {
        if(widgetinfo && widgetinfo.widgets && widgetinfo.widgets.find(o => o.name === 'currency')) {
            return true;
        }
        return false;
    }

    const isWeather = (searchResp) => {
        if(searchResp && searchResp.WidgetInfo && searchResp.WidgetInfo.widgets && searchResp.WidgetInfo.widgets.find(o => o.name === 'weather')) {
            return true;
        }
        return false;
    }

    const isCalculator = (searchResp) => {
        if(searchResp && searchResp.WidgetInfo && searchResp.WidgetInfo.widgets && (searchResp.WidgetInfo.widgets.find(o => o.name === 'calculator' || searchResp.WidgetInfo.widgets.find(o => o.name === 'calculate')))) {
            return true;
        }
        if(searchResp && searchResp.computation) {
            let regExpression = /[^\s\^\u2009]*$/;
            if (!isNaN(regExpression.exec(searchResp.computation.value))) { 
                return true;
            } else {
                return false;
            }
        }
        return false;
    }

    const isTranslate = (searchResp) => {
        if(searchResp && searchResp.WidgetInfo && searchResp.WidgetInfo.widgets && searchResp.WidgetInfo.widgets.find(o => o.name === 'translate')) {
            return true;
        }
        if(searchResp && searchResp.translations) {
            return true;
        }
        return false;
    }

    // WIDGET WRITERS: set up any props you need (things that come from searchResp, searchResp.widgetInfo) in this function
    const GetWidgetProps = (location, name, searchResp) => {
        if(name === "weather") {
            if(location === "top") {
                return {size: "large"};
            } // if small widget, will return no size prop
            const widgetdata = searchResp.WidgetInfo.widgets.find(o => o.name === 'weather');
            return {location: widgetdata?.location};
        } else if(name === "map") {
            let widgetInfo = searchResp.WidgetInfo;
            return {widgetInfo: widgetInfo};
        } else if (name === "affsearch") {
            let affsearchInfo = searchResp.AffSearchInfo;
            return {affsearchinfo: affsearchInfo};
        } else if(name === "translate") {
            if(searchResp && searchResp.translations) {
                return {fromText: searchResp.translations.originalText,
                        fromLang: searchResp.translations.inLanguage,
                        toText: searchResp.translations.translatedText,
                        toLang: searchResp.translations.translatedLanguageName}
            } else {
                return {fromText: '', toText: '', fromLang: '', toLang: ''};
            }
        } else if(name === "currency") {
            const widgetdata = searchResp.WidgetInfo.widgets.find(o => o.name === 'currency');
            return {amount: widgetdata?.amount, from: widgetdata?.from, to: widgetdata?.to};
        } else if(name === "calculator") {
            // extract props
            if(searchResp && searchResp.computation) {
                return {expression: searchResp.computation.expression,
                    value: searchResp.computation.value}
            } else {
                return {};
            }
        }
         return {};
    } 

    // WIDGET WRITERS: logic to choose your widget goes in here (look for "setName")
    //   -- order matters. highest precedence first.
    if(searchResp && searchResp.WidgetInfo) {
        let setName = null;
        if(isWeather(searchResp)) {
            setName = "weather";
        } else if(isCurrency(searchResp.WidgetInfo)) {
            setName = "currency";
        } else if(isCalculator(searchResp)) {
            setName = "calculator";
        } else if(isTranslate(searchResp)) {
            setName = "translate";
        } else if(isMap(searchResp)) {
            setName = "map";
        } else if(isShopping(searchResp.WidgetInfo)) {
            setName = "affsearch";
        } else {
            setName = "NA";
        }

        // WIDGET WRITERS: you can test your widget by setting "&testflag=true" in your url (hasTestFlag() == true)
        //                 note that it won't go "live" for customers until we add it into this array (don't do this yourself!)
        // logic is: return widget on just the "all" tab when testing or if it's in the array
        //           return affsearch on any tab
        if(setName && 
                ((searchResp._type === "SearchResponse" && (["map", "affsearch", "currency", "translate", "weather", "calculator"].includes(setName) || hasTestFlag())) ||
                 (searchResp._type !== "SearchResponse" && ["affsearch"].includes(setName)))) {
            return {name: setName, props: GetWidgetProps(location, setName, searchResp)};
        } else {
            return {name: "NA"};
        }
    }
    return ({});
}
